import * as React from 'react';

// Utils
import { isNil } from '@src/shared/src/util/general';
// Constants
import { ENVIRONMENT, VEHICLE_TYPES } from '@src/shared/src/const/app';
// Actions
// Models
import { TariffFareTermsModel } from '@src/shared/src/models';
// Interfaces
// Components
import { TrainSeatReservation } from './TrainSeatReservation';
import { TariffPlaneFareTerms } from './TariffPlaneFareTerms';
import { CityTicketTerms } from './CityTicketTerms';
import FareTermsConditionsModal from './FareTermsConditionsModal';
// Styles
import '../styles/TariffFareTerms.scss';

type Props = {
  fareName: string;
  fareTerms: TariffFareTermsModel;
  vehicle: VEHICLE_TYPES;
  profileLocale: string;
  env: ENVIRONMENT;
  basketItemId: number;
  requestSeatReservation: boolean;
  setRequestSeatReservation: (value: boolean) => void;
  isBasketEditable: boolean;
};

const TariffFareTerms: React.FC<Props> = (props: Props) => {
  const getFareTermsByVehicle = () => {
    if (!isNil(props.fareTerms)) {
      switch (props.vehicle.toUpperCase()) {
        case VEHICLE_TYPES.TRAIN:
          return (
            <TrainSeatReservation
              env={props.env}
              fareTerms={props.fareTerms}
              basketItemId={props.basketItemId}
              requestSeatReservation={props.requestSeatReservation}
              setRequestSeatReservation={props.setRequestSeatReservation}
              isBasketEditable={props.isBasketEditable}
            />
          );
        case VEHICLE_TYPES.PLANE:
          return (
            <TariffPlaneFareTerms fareTerms={props.fareTerms} profileLocale={props.profileLocale} />
          );
        default:
          return null;
      }
    }
    return null;
  };

  return (
    <div className="lp-tariff-fare-terms">
      {getFareTermsByVehicle()}
      <CityTicketTerms tariffFareTerms={props.fareTerms} />
      {(!isNil(props.fareTerms.conditions) || !isNil(props.fareTerms.cancellations) || !isNil(props.fareTerms.reissue)) && (
        <div className="lp-tariff-fare-terms-wrapper">
          <FareTermsConditionsModal
            fareConditions={props.fareTerms.conditions}
            fareCancellations={props.fareTerms.cancellations}
            fareReissue={props.fareTerms.reissue}
            fareName={props.fareName}
            showLinkIcon={true}
          />
        </div>
      )}
    </div>
  );
};

export default TariffFareTerms;
